<template>
  <v-dialog persistent v-model="openModal" max-width="800px">
    <v-form ref="formPessoaModal">
      <v-card>
        <v-card-title
          class="primary body-2 white--text"
        >{{current === false ? 'Novo Usuário' : 'Editando: ' + current.nome}}</v-card-title>
        <v-card-text style="margin-top: 20px">
          <div class="mx-2 my-2">
            <alert></alert>
          </div>
          <v-row>
            <v-col cols="12" md="4">
              <custom-input-mask
                outlined
                ref="txtDocumento"
                id="txDocumento"
                :disabled="current !== false"
                autofocus
                :rules="requiredRule"
                label="CPF"
                :mask="['###.###.###-##']"
                v-model="dataModal.cpf"
              ></custom-input-mask>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-uppercase
                outlined
                ref="txNome"
                :rules="requiredRule"
                label="Nome"
                v-model="dataModal.nome"
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-uppercase outlined label="Email" v-model="dataModal.email" />
            </v-col>
            <v-col cols="12" md="4">
              <custom-input-mask
                outlined
                :rules="requiredRule"
                label="Celular"
                :mask="['(##)#####-####','(##)####-####']"
                v-model="dataModal.celular"
              ></custom-input-mask>
            </v-col>
             <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                  <v-select
                    outlined
                    :rules="requiredRule"
                    v-model="dataModal.tipo"
                    item-text="nome"
                    item-value="id"
                    :items="displayTipo"
                    label="Tipo do Usuário"
                  ></v-select>
                </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="fecharModal()" color="error">
            <v-icon left>mdi-close-circle</v-icon>Cancelar
          </v-btn>
          <v-btn @click="submit()" color="primary">
            <v-icon left>mdi-content-save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import { mapActions } from "vuex";
import Alert from "../../components/helper/Alert";
import CustomInputMask from "../../components/shared/CustomInputMask";

export default {
  mixins: [rules],
  components: {
    Alert,
    CustomInputMask,
  },
  props: {
    openModal: {
      type: Boolean,
      required: true,
    },
    current: {
      type: [Object, Boolean],
      default: false,
    },
    callback: {
      type: [Boolean, Function],
      default: false,
    },
  },
  data() {
    return {
      dataModal: {},
    };
  },
  watch: {
    openModal(novoValor) {
      if (novoValor === true) {
        if (this.current !== false) {
            this.dataModal.id = this.current.id;
            this.dataModal.cpf = this.current.cpf;
            this.dataModal.nome = this.current.nome;
            this.dataModal.email = this.current.email;
            this.dataModal.celular = this.current.celular;
            this.dataModal.tipo = this.current.tipo;
        } else {
            this.limparDados();
        }
        if (this.$refs.formPessoaModal) {
          if (this.current === false) {
            //this.$refs.formPessoaModal.reset();    
            this.limparDados();        
            setTimeout(() => this.$refs.formPessoaModal.inputs[0].focus(), 100);
          } else {
            setTimeout(() => this.$refs.formPessoaModal.inputs[1].focus(), 100);
          }
        }
      } else {
          this.limparDados();
      }
    },
  },
  created() {},
  computed: {
      displayTipo() {
          return [
              {id: 1, nome: 'ESCRITÓRIO'},
              {id: 2, nome: 'CLIENTE'}
          ]
      }
  },
  methods: {
    ...mapActions("usuario", {
      salvarPessoa: "salvar",
      atualizarPessoa: "atualizar",
    }),
    submit() {
      if (this.$refs.formPessoaModal.validate()) {
        if (this.current === false) {
          this.salvarPessoa(this.dataModal).then((data) => {
            this.openAlertSuccess("Usuário cadastrado com sucesso");
            this.fecharModal();
            if (this.callback) {
              this.callback(data);
            }
          });
        } else {
          this.atualizarPessoa(this.dataModal).then((data) => {
            this.openAlertSuccess("Usuário atualizado com sucesso");
            this.fecharModal();
            if (this.callback) {
              this.callback(data);
            }
          });
        }
      }
    },
    limparDados() {
      delete this.dataModal.id;
      this.dataModal.cpf = "";
      this.dataModal.nome = "";
      this.dataModal.email = "";
      this.dataModal.celular = "";
      this.dataModal.tipo = 2;
    },
    fecharModal() {
      this.$emit("update:openModal", false);
    },
  },
};
</script>
